import { BoardLayout } from "@/components/board/BoardLayout";
import { ErrorBanner } from "@/components/board/ErrorBanner";
import { LoadingState } from "@/components/board/LoadingState";
import { AvailabilityBoard } from "@/components/availability/AvailabilityBoard";
import { useUserSettings } from "@/contexts/UserSettingsContext";
import { useMakersBoardData } from "@/hooks/useMakersBoardData";
import { OooProvider } from "@/contexts/OooContext";
import type { ReactNode } from "react";

interface AvailabilityTabProps {
  // Rendered as the first child of the board (the page-level tab switcher).
  header?: ReactNode;
}

/**
 * "Availability" tab - employee availability timeline, formerly the standalone
 * Availability page.
 */
export function AvailabilityTab({ header }: AvailabilityTabProps) {
  const { employees, loading, error } = useMakersBoardData();
  // Gate on settings so the board mounts with the user's saved defaults already
  // applied (AvailabilityBoard seeds its state from these props on first render).
  const { settings, loading: settingsLoading } = useUserSettings();

  return (
    <BoardLayout fill>
      {header}
      {error ? <ErrorBanner message={error} entityName="employees" /> : null}

      {loading || settingsLoading ? (
        <LoadingState message="Loading availability..." />
      ) : (
        <OooProvider>
          <AvailabilityBoard
            employees={employees}
            defaultAvailabilityMode={settings.availabilityMode}
            defaultMinAvailableHours={settings.availabilityMinHours}
          />
        </OooProvider>
      )}
    </BoardLayout>
  );
}
